import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { GoogleComponent } from '@pages/utils/google.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';

@Component({
    selector: 'app-alert-recarga-certa',
    templateUrl: './alert-recarga-certa.component.html',
    styleUrls: ['./alert-recarga-certa.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TagManagerDirective]
})
export class AlertRecargaCertaComponent extends GoogleComponent implements OnChanges {
  @Input() alertRecargaCerta = false;
  @Input() mensagemErro = 'Você está fazendo seu pedido sem Recarga Certa. Deseja fazer pedido com economia?';
  @Input() tituloMensagemErro = 'Recarga Certa';
  @Output() alertRecargaCertaFechou = new EventEmitter();

  private readonly sectionApp = 'importacao-realizacao-pedidos';
  private readonly screenName = 'importacao-realizacao-pedidos:recarga-certa';
  private readonly screenType = 'modal';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alertRecargaCerta?.currentValue) {
      this.pushScreenView(this.sectionApp, this.screenName, this.screenType);
    }
  }

  ativarRecargaCerta() { this.alertRecargaCertaFechou.emit(true); }

  continuarSemRecargaCerta() { this.alertRecargaCertaFechou.emit(false); }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }
}
